// 打印类属性、方法定义   url: https://github.com/xyl66/vuePlugs_printjs
/* eslint-disable */
const Print = function (dom, options) {
  if (!(this instanceof Print)) return new Print(dom, options);

  this.options = this.extend({
    'noPrint': '.no-print'
  }, options);

  if ((typeof dom) === "string") {
    this.dom = document.querySelector(dom);
  } else {
    this.isDOM(dom)
    this.dom = this.isDOM(dom) ? dom : dom.$el;
  }

  this.init();
};
Print.prototype = {
  init: function () {
    var content = this.getStyle() + this.getHtml();
    this.writeIframe(content);
  },
  extend: function (obj, obj2) {
    for (var k in obj2) {
      obj[k] = obj2[k];
    }
    return obj;
  },

  getStyle: function () {
     var str = "",
     // 获取整个页面的所有样式表元素 element 列表： querySelectorAll(".highlighted") .querySelector("#test")  .querySelectorAll("div.note, div.alert")
     styles = document.querySelectorAll('style,link');

    for (var i = 0; i < styles.length; i++) { // 遍历样式元素
      // element.outerHTML :  包含参数 element 本身，如 <div id="d">好的</div> ，$('#d').outerHTML='<p>发布会</p>'
      // <div id="d">好的</div> 将整个被替换为 <p>发布会</p>
      str += styles[i].outerHTML;
    }
    str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";

    return str;
  },

  getHtml: function () {
    var inputs = document.querySelectorAll('input'); // 返回所有指定选择器的元素列表
    var textareas = document.querySelectorAll('textarea');
    var selects = document.querySelectorAll('select');

    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
        if (inputs[k].checked == true) {
          inputs[k].setAttribute('checked', "checked")
        } else {
          inputs[k].removeAttribute('checked')
        }
      } else if (inputs[k].type == "text") {
        // input已经渲染出了内容，为什么要再次将input[K].value 进行 setAttribute
        // setAttribute('value', 124) 改变了 input 在 dom 中的源代码
        // getElementByID('**').value = 124 并没有改变 input 在dom 中的源代码
        inputs[k].setAttribute('value', inputs[k].value)
      } else {
        inputs[k].setAttribute('value', inputs[k].value)
      }
    }

    for (var k2 = 0; k2 < textareas.length; k2++) {
      if (textareas[k2].type == 'textarea') {
        textareas[k2].innerHTML = textareas[k2].value
      }
    }

    for (var k3 = 0; k3 < selects.length; k3++) {
      if (selects[k3].type == 'select-one') {
        var child = selects[k3].children;
        for (var i in child) {
          if (child[i].tagName == 'OPTION') {
            if (child[i].selected == true) {
              child[i].setAttribute('selected', "selected")
            } else {
              child[i].removeAttribute('selected')
            }
          }
        }
      }
    }
    // 包裹要打印的元素
    // fix: https://github.com/xyl66/vuePlugs_printjs/issues/36
    // let outerHTML = this.wrapperRefDom(this.dom).outerHTML  ----- 作者原先的写法
    let printDom = this.dom.cloneNode(true)
    // 清除 class 为 noPreview 的元素
    let noPreviews = printDom.querySelectorAll(`.noPreview`);
    for (var i = 0; i < noPreviews.length; i++) {
      noPreviews[i].outerHTML = null;
    }
    let outerHTML = printDom.outerHTML /* ------- 在页面中全部写成内联样式，在此项目中因此不需要添加父级元素的样式 ------ */
    return outerHTML; /* ------- 到此获得的 outerHTML 是正常的 ------- */
  },

  /* ----- 获取父级元素的样式将DOM进行包裹后，用的时候有点问题：部分内容打印不出来，全部写成内联样式后正常打印 ------ */
  // 向父级元素循环，包裹当前需要打印的元素
  // 防止根级别开头的 css 选择器不生效
  wrapperRefDom: function (refDom) {
    let prevDom = null
    let currDom = refDom
    // 判断当前元素是否在 body 中，不在文档中则直接返回该节点
    if (!this.isInBody(currDom)) return currDom

    while (currDom) {
      if (prevDom) {
        let element = currDom.cloneNode(false)
        element.appendChild(prevDom)
        prevDom = element
      } else {
        prevDom = currDom.cloneNode(true) // 如果为true,则该节点的所有后代节点也都会被克隆,如果为false,则只克隆该节点本身.
      }

      currDom = currDom.parentElement   // 用父级元素包裹当前节点元素
    }

    return prevDom
  },

  // content 是要打印内容： 含 dom 及 css
  writeIframe: function (content) {
    var w, doc, iframe = document.createElement('iframe'),
      f = document.body.appendChild(iframe);
    iframe.id = "myIframe";
    //iframe.style = "position:absolute;width:0;height:0;top:-10px;left:-10px;";
    iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;'); /* ---- 作者原先写法，用的时候发现 DOM 内容超出了打印框， ---- */
    w = f.contentWindow || f.contentDocument;
    doc = f.contentDocument || f.contentWindow.document;
    doc.open();
    doc.write(content);
    doc.close();
    var _this = this
    iframe.onload = function(){
      _this.toPrint(w);
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 100)
    }
  },

  toPrint: function (frameWindow) {
    try {
      setTimeout(function () {
        frameWindow.focus();
        try {
          if (!frameWindow.document.execCommand('print', false, null)) {
            frameWindow.print();
          }
        } catch (e) {
          frameWindow.print();
        }
        frameWindow.close();
      }, 10);
    } catch (err) {
      console.log('err', err);
    }
  },
  // 检查一个元素是否是 body 元素的后代元素且非 body 元素本身
  isInBody: function (node) {
    return (node === document.body) ? false : document.body.contains(node);
  },
  isDOM: (typeof HTMLElement === 'object') ?
    function (obj) {
      return obj instanceof HTMLElement;
    } :
    function (obj) {
      return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
};
const MyPlugin = {}
MyPlugin.install = function (Vue, options) {
  // 4. 添加实例方法
  Vue.prototype.$print = Print
}
export default MyPlugin